import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { loginDetails } from '../Home/Login';


const AddNewMenu = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [flag, setFlag] = useState(false);
    const [userName, setUserName] = useState("");
    const [userId, setUserId] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [aadharNumber, setAadharNumber] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [emailId, setEmailId] = useState("");
    const [menuTitleValue, setMenuTitleValue] = useState("");
    const [remarkValue, setRemarkValue] = useState("");
    const [isActive, setIsActive] = useState("N");
    const [formsData, setFormsData] = useState([]);
    const [departmentData, setDepartmentData] = useState([]);
    const [schemeData, setSchemeData] = useState([]);
    const [designationData, setDesignationData] = useState([]);
    const [userTypeData, setUserTypeData] = useState([]);
    const [userRoleData, setUserRoleData] = useState([]);
    const [statesData, setStatesData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [subDistrictData, setSubDistrictData] = useState([]);
    const [blockData, setBlockData] = useState([]);
    const [villageData, setVillageData] = useState([]);
    const [departmentValue, setDepartmentValue] = useState("");
    const [schemeValue, setSchemeValue] = useState("");
    const [formCodeValue, setFormCodeValue] = useState("");
    const [designationValue, setDesignationValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [districtValue, setDistrictValue] = useState("");
    const [subDistrictValue, setSubDistrictValue] = useState("");
    const [blockValue, setBlockValue] = useState("");
    const [villageValue, setVillageValue] = useState("");
    const [userTypeValue, setUserTypeValue] = useState("");
    const [userRoleValue, setUserRoleValue] = useState("");
    const [userCode, setUserCode] = useState("");
    const [otp, setOtp] = useState("");
    const [menuCode, setMenuCode] = useState("");
    const [parentCode, setParentCode] = useState("");
    const [sortingOrder, setSortingOrder] = useState("");
    const [parentMenuData, setParentMenuData] = useState([]);
    const [parentMenuValue, setParentMenuValue] = useState("")
    useEffect(() => {
        const fetchData = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/forms`);
            setFormsData(result.data.dataContent);
        };
        fetchData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/menu`);
            let filterArray = result.data.dataContent.filter((x) => { return x.parentCode === 0 })
            setParentMenuData(filterArray)
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (flag == true) {
            fetchData2();
        }
    }, [flag])

    useEffect(() => {
        // useEffect to set defaultValue in dropdown meun
        if (state) {
            setMenuCode(state.cropSurveyCode.menuCode)
            setParentMenuValue(state.cropSurveyCode.parentCode)
            setSortingOrder(state.cropSurveyCode.sortingOrder)
            setMenuTitleValue(state.cropSurveyCode.menuTitle)
            setFormCodeValue(state.cropSurveyCode.formsCode)
            setRemarkValue(state.cropSurveyCode.remarks)
            setUserName(state.cropSurveyCode.userName)
            setUserId(state.cropSurveyCode.userId)
            setMobileNumber(state.cropSurveyCode.mobile)
            setAadharNumber(state.cropSurveyCode.aadhar)
            setEmailId(state.cropSurveyCode.emailId)
            setPassword(state.cropSurveyCode.password)
            setConfirmPassword(state.cropSurveyCode.password)
            setUserCode(state.cropSurveyCode.userCode)
            setOtp(state.cropSurveyCode.otp)
            getUserType()
            getScheme()
            getStates()
   

            handleState(state.cropSurveyCode.stateCode)
            handleDistrict(state.cropSurveyCode.districtCode)

            handleSubDistrict(state.cropSurveyCode.subDistrictCode, state.cropSurveyCode.districtCode)
            setBlockValue(state.cropSurveyCode.blockCode)
            setVillageValue(state.cropSurveyCode.villageCode)
            handleBlock(state.cropSurveyCode.subDistrictCode, state.cropSurveyCode.districtCode)
          

            setUserTypeValue(state.cropSurveyCode.userTypeCode)
            setSchemeValue(state.cropSurveyCode.schemeCode)
            setDesignationValue(state.cropSurveyCode.designationCode)
            setDistrictValue(state.cropSurveyCode.districtCode)
           
          
            setIsActive(state.cropSurveyCode.isActive)
            setStateValue(state.cropSurveyCode.stateCode)
            setDepartmentValue(state.cropSurveyCode.departmentCode)
            //setSchemeValue(state.cropSurveyCode.departmentCode)
            setSubDistrictValue(state.cropSurveyCode.subDistrictCode)
            setBlockValue(state.cropSurveyCode.blockCode)
            setVillageValue(state.cropSurveyCode.villageCode)

            //document.getElementById("userRoles").selectedIndex = state.cropSurveyCode.userRoleCode;
            //document.getElementById("Designation").selectedIndex = state.cropSurveyCode.designationCode;
            //document.getElementById("Department").selectedIndex = state.cropSurveyCode.departmentCode;
            //document.getElementById("State").selectedIndex = state.cropSurveyCode.stateCode;
            //document.getElementById("District").selectedIndex = state.cropSurveyCode.districtCode;
            //document.getElementById("subDistrict").selectedIndex = state.cropSurveyCode.subDistrictCode;
            //document.getElementById("Block").selectedIndex = state.cropSurveyCode.blockCode;
            //document.getElementById("village").selectedIndex = state.cropSurveyCode.villageCode;
        }
    }, [])

    function getUserType() {
        const fetchUserType = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/usertype`);
            setUserTypeData(result.data.dataContent);
        };
        fetchUserType();
    }

    function getScheme() {
        const fetchScheme = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/scheme`);
            setSchemeData(result.data.dataContent);
        };
        fetchScheme();
    }

    function getStates() {
        const fetchStates = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Cropicstates`);
            setStatesData(result.data.dataContent);
        };
        fetchStates();
    }


    function handleState(value) {
        setStateValue(value);
        setDistrictData([])

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "stateCode": Number(value)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Cropicdistrict`, requestOptions)
            .then(response => response.text())
            .then(result => setDistrictData(JSON.parse(result).dataContent))
            .catch(error => console.log('error', error));


    }
    function handleDistrict(value) {
        //setStateValue(value);
        //setDistrictValue([])
        setDistrictValue(value)

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "DistrictCode": Number(value)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/subdistrict`, requestOptions)
            .then(response => response.text())
            .then(result => setSubDistrictData(JSON.parse(result).dataContent))
            .catch(error => console.log('error', error));


    }
    function handleSubDistrict(value, DDValue) {

        if (DDValue != null) {
            var raw = JSON.stringify({
                "subdistrictcode": value,
                "districtcode": DDValue
            });

        } else {
            var raw = JSON.stringify({
                "subdistrictcode": value,
                "districtcode": districtValue
            });

        }

        setSubDistrictValue(value)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/block`, requestOptions)
            .then(response => response.text())
            .then(result => setBlockData(JSON.parse(result).dataContent))
            .catch(error => console.log('error', error));

    }
    function handleBlock(subDvalue, DValue) {

        if (subDvalue != null && DValue != null) {
            var raw = JSON.stringify({
                "subdistrictcode": subDvalue,
                "districtcode": DValue
            });

        } else {
            var raw = JSON.stringify({
                "subdistrictcode": subDistrictValue,
                "districtcode": districtValue
            });

        }
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");



        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/village`, requestOptions)
            .then(response => response.text())
            .then(result => setVillageData(JSON.parse(result).dataContent))
            .catch(error => console.log('error', error));

    }

    function ValidateMenu() {
        let valid = false;
         if(schemeValue === "") {
             valid = false;
            alert("Select Correct Scheme")
            return;
         }else {
             valid = true
         }
         if(parentMenuValue === "") {
             valid = false;
            alert("Select Correct Parent Menu")
            return;
         }else {
             valid = true
         }
         if(menuTitleValue === "") {
             valid = false;
            alert("Enter Correct Menu Title")
            return;
         }else {
             valid = true
         }
         if(formCodeValue === "") {
            valid = false;
            alert("Select Attached Form")
            return;
         }else {
             valid = true;           
         }
         if(valid === true) {
            state ? UpdateMenu() : AddNewMenu()
         }
     
       }

    function AddNewMenu() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "ParentCode": Number(parentMenuValue),
            "SchemeCode": schemeValue,
            "MenuTitle": menuTitleValue,
            "FormsCode": formCodeValue,
            "SortingOrder": "1",
            "Remarks": remarkValue,
            "CreatedByUC": localStorage.getItem("userCodeGlobal"),
            "IsActive": isActive
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/menu`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/usermanagement/menu")
                }

            })
            .catch(error => console.log('error', error));
       
    }

    function UpdateMenu() {
       
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "MenuCode": menuCode,
            "SchemeCode": schemeValue,
            "ParentCode": parentMenuValue,
            "MenuTitle": menuTitleValue,
            "FormsCode": formCodeValue,
            "SortingOrder": sortingOrder,
            "Remarks": remarkValue,
            "IsActive": isActive,
            "ModifiedByUC": localStorage.getItem("userCodeGlobal")
        });

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/menu`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/usermanagement/menu")
                }

            })
            .catch(error => console.log('error', error));
    }

    async function fetchData2() {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/forms`);
        setFormsData(result.data.dataContent);
    }

    function handleResetForm() {
        setSchemeValue("")
        setParentMenuData([])
        setMenuTitleValue("")
        setFormCodeValue("")
        setRemarkValue("")
    }

    return (
        <>
          
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Add New Menu</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">Add New Menu</li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="card dashboard">
                        <div className="card-body">

                            <form className="g-3 addNewUser">
                                <div className="row">
                                    <h5 className="formgrouping">Form Details</h5>

                                    <div className="col-md-3">
                                        <label for="scheme" className="form-label">Scheme Name</label>
                                        <select id="scheme" required className="form-select" onClick={getScheme} onChange={e => setSchemeValue(e.target.value)} value={schemeValue}>
                                            <option selected>Choose...</option>
                                            {schemeData.map((item, id) => {
                                                return <option key={id} value={item.schemeCode}> {item.schemeName}</option>
                                            })}
                                        </select>
                                    </div>

                                    <div className="col-md-3">
                                        <label for="parent" className="form-label">Parent Menu</label>
                                        <select id="parent" required className="form-select" onChange={e => setParentMenuValue(e.target.value)} value={parentMenuValue}>
                                            <option selected value="0">Choose...</option>
                                            {parentMenuData.map((item, id) => {
                                                return <option key={id} value={item.menuCode} > {item.menuTitle}</option>
                                            })}
                                        </select>
                                    </div>

                                    <div className="col-md-3">
                                        <label for="menutile" className="form-label">Menu Title</label>
                                        <input type="text" className="form-control" required placeholder="Menu Title" onChange={e => setMenuTitleValue(e.target.value)} value={menuTitleValue} />
                                    </div>                                                                   

                                    <div className="col-md-3">
                                        <label for="formCode" className="form-label">Attached Form</label>
                                        <select id="formCode" required className="form-select" onChange={e => setFormCodeValue(e.target.value)} value={formCodeValue}>
                                            <option selected>Choose...</option>
                                            {formsData.map((item, id) => {
                                                return <option key={id} value={item.rO_FormCode}> {item.formName}</option>
                                            })}
                                        </select>
                                    </div>

                                    <div className="col-md-3">
                                        <label for="remark" className="form-label">Remarks</label>
                                        <input type="text" className="form-control" required placeholder="Remarks" onChange={e => setRemarkValue(e.target.value)} value={remarkValue} />
                                    </div>

                                    {state ? <div className="col-sm-3">
                                        <label for="remark" className="form-label">Action</label>
                                        <div className="form-check" onClick={() => { setIsActive(isActive === "Yes" ? "N" : "Y") }}>
                                           
                                            <input className="form-check-input" type="checkbox" name="gridCheck1" id="gridCheck1" checked={isActive === "Yes" ? 'true' : ''} />
                                            <label className="form-check-label" for="gridCheck1"> Is Active </label>
                                        </div>
                                    </div> : ""}
                                  
                             <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                                        {state ? <button className="btn btn-success me-md-2" type="button" onClick={ValidateMenu}>Update</button> : <button className="btn btn-success me-md-2" type="button" onClick={ValidateMenu}>Save</button>}

                                        <button className="btn btn-outline-primary" type="button" onClick={handleResetForm}>Reset</button>
                                        <button className="btn btn-outline-danger" type="button" onClick={() => navigate("/usermanagement/menu")}>Cancel</button>
                                    </div>


                                </div>
                            </form>
                        </div>
                    </div>




                </section>
            </main>
           
        </>
    )
}

export default AddNewMenu;